export const smeBusinessToolkitTitles = {
  'Original free account': {
    type: 'free',
    amount: '0',
    className: 'sme-business-toolkit__col sme-business-toolkit__col--thin sme-business-toolkit__col--border',
    new: false,
    vat: false,
    link: '/business-account/',
    linkText: 'Get started'
  },
  'The Business Toolkit': {
    type: 'toolkit',
    amount: '7',
    className: 'sme-business-toolkit__col sme-business-toolkit__col--thin sme-business-toolkit__col--grey',
    vat: true,
    link: '#cta-footer',
    linkText: 'Get started'
  }
};

export const smeBusinessToolkitSubHeadings = {
  'Business Toolkit Features': {
    invoices: {
      name: 'Invoices and auto-matching',
      bio: 'Create and manage unlimited invoices directly from your desktop. When you get paid, just match your invoices in a single click'
    },
    email: {
      name: 'Email integrations',
      bio: 'Link your Google, Outlook or Hotmail email to the Business Toolkit to issue invoices directly from your bank account'
    },
    tax: {
      name: 'HMRC Tax estimation (sole trader only)',
      bio: 'Estimate your self-employed tax (SA103F), national insurance and student loan liabilities'
    },
    vatrecord: {
      name: 'Record VAT on transactions',
      bio: 'Record your VAT, and we’ll calculate your VAT return if you’re on cash accounting or flat rate (cash basis)'
    },
    smarttax: {
      name: 'Smart tax savings',
      bio: 'Set aside money for your self-employed tax and VAT bills in a click'
    },
    vatsubmit: {
      name: 'MTD VAT submission',
      bio: 'Connect your account to HMRC and submit your VAT return through Making Tax Digital'
    },
    bookkeeping: {
      name: 'Bookkeeping to-do list',
      bio: 'See what needs to be done in a handy interactive to-do list, so you can stay on top of your bookkeeping admin'
    },
    bills: {
      name: 'Manage bills',
      bio: 'Upload bills, schedule payments and track your expenses. Auto-sync Direct Debits from Spaces'
    }
  },
  'Starling Original Features': {
    current: {
      name: 'Free UK current account',
      bio: 'Starling is a registered bank. Up to £85,000 of your eligible deposits will be FSCS protected'
    },
    multi: {
      name: 'Multi-director access',
      bio: 'Manage an account with the other directors of your business'
    },
    integrations: {
      name: 'Integration with accounting software',
      bio: 'Link your account with QuickBooks, Xero or FreeAgent'
    },
    gbp: {
      name: 'Free UK bank transfers',
      bio: 'Send and receive pounds within the UK, completely free of charge'
    },
    international: {
      name: 'International payments',
      bio: 'Make payments to 30+ countries with real-time exchange rates and no hidden fees'
    },
    fees: {
      name: 'No debit card fees abroad',
      bio: 'Use your Starling card on business abroad, with zero fees'
    },
    support: {
      name: '24/7 UK support',
      bio: 'Get in touch, wherever you are, via phone, email or in-app chat'
    },
    expenses: {
      name: 'Automated business categories',
      bio: 'We’ll put your expenses into relevant business categories for you'
    },
    receipt: {
      name: 'Receipt capture',
      bio: 'Add receipts to transactions while you’re on the go'
    },
    savings: {
      name: 'Spaces',
      bio: 'Set aside money towards your business goals'
    },
    pay: {
      name: 'Apple, Google, Samsung and Garmin Pay',
      bio: 'Pay with your mobile or smart watch'
    },
    banking: {
      name: 'Mobile and online banking',
      bio: 'Manage your finances at home, in the office or on the go'
    },
    cheque: {
      name: 'Mobile cheque deposits',
      bio: 'Pay cheques in via the Starling app and receive the funds within two working days'
    },
    deposits: {
      name: 'Cash deposits',
      bio: 'Pay in cash at your local Post Office, there’s a 0.7% charge (minimum charge of £3) for each deposit'
    },
    atm: {
      name: 'ATM withdrawals',
      bio: '£300 fee-free every day, at home or abroad'
    },
    control: {
      name: 'Card control',
      bio: 'Freeze your card in the app if you lose your card on the go'
    },
    notifications: {
      name: 'Instant notifications',
      bio: 'We’ll let you know whenever you get paid or spend from your account'
    },
    connected: {
      name: 'Connect to other business services',
      bio: 'Access a range of products and services in the Starling Business Marketplace that you can link to your business or sole trader bank account'
    },
    billsmanager: {
      name: 'Bills Manager',
      bio: 'Get a clearer view of your money by paying Direct Debits and standing orders from a separate Saving Space.'
    }
  }
};

export const smeBusinessToolkitData = {
  toolkit: {
    expenses: true,
    receipt: true,
    integrations: true,
    connected: true,
    email: true,
    multi: true,
    invoices: true,
    tax: true,
    vatrecord: true,
    vatsubmit: true,
    bills: true,
    bookkeeping: true,
    current: true,
    gbp: true,
    international: true,
    savings: true,
    pay: true,
    cheque: true,
    banking: true,
    deposits: true,
    fees: true,
    atm: true,
    support: true,
    control: true,
    notifications: true,
    billsmanager: true,
    smarttax: true
  },
  free: {
    expenses: true,
    receipt: true,
    integrations: true,
    connected: true,
    email: false,
    multi: true,
    invoices: false,
    tax: false,
    vatrecord: false,
    vatsubmit: false,
    bills: false,
    bookkeeping: false,
    current: true,
    gbp: true,
    international: true,
    savings: true,
    pay: true,
    cheque: true,
    banking: true,
    deposits: true,
    fees: true,
    atm: true,
    support: true,
    control: true,
    notifications: true,
    billsmanager: true,
    smarttax: false
  }
};
